<template>
  <!--
  Диалог для установки лунок источников спектра для зонда набора зондов
  Задачи:
    выбрать зонд набора зондов, которому установить (или дополнить)
    выбранные лунки как источник спектра
  -->
  <default-dialog
    ref="dlgDefault"
    v-model="value"
    width="90%"
    max-width="950px"
    @accepted="$emit('accepted', $event)"
    @closing="$emit('closing', $event)"
  >
    <template #header>
      <v-layout fluid>

        <v-flex fluid>
          <span>Set probe plex probe spectra source wells</span>
        </v-flex>
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-icon v-on="on" style="margin-left: 8px;">
              mdi-cog
            </v-icon>
          </template>
          <template #default>
            <pre>{{ JSON.stringify(state, null, 2) }}</pre>
          </template>
        </v-tooltip>

      </v-layout>
    </template>

    <template #content>
      <v-container grid-list-md style="padding: 0; width: 100%;">
        <v-layout row fill-height>

          <!-- probePlex -->
          <v-flex xs12 sm12 md6 lg6 xl6>
            <v-select
              label="Probe plex" required
              dense outlined hide-details
              :items="probePlex_list_filtered" v-model="probePlex_selected"
              item-value="id" item-text="name"
            ></v-select>
          </v-flex>

          <!-- probePlexProbe -->
          <v-flex xs12 sm12 md6 lg6 xl6>
            <v-select
              label="Probe of probe plex" required
              dense outlined hide-details
              :items="probePlexProbe_list_filtered" v-model="probePlexProbe_selected"
              item-value="id"
            >
              <template #selection="{ item, index }">
                <v-row no-gutters align="center" style="width: 100%;">
                  <span>{{ item.probe.name }}</span>
                  <v-spacer></v-spacer>
                  <v-chip
                    :color="item.probe.color ? item.probe.color: item.probe.dye.color"
                    text-color="white" small
                  >
                    {{ item.probe.dye.name }}
                  </v-chip>
                </v-row>
              </template>
              <template #item="{ active, item, attrs, on }">
                <v-list-item v-on="on" v-bind="attrs">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-row no-gutters align="center">
                        <span>{{ item.probe.name }}</span>
                        <v-spacer></v-spacer>
                        <v-chip
                          :color="item.probe.color ? item.probe.color: item.probe.dye.color"
                          text-color="white" small
                        >
                          {{ item.probe.dye.name }}
                        </v-chip>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </v-flex>

          <!-- Probe plex probe spectra sources already -->
          <v-flex xs12 sm6 md8 lg8 xl9>
            <fieldset
              style="border-radius: 4px; border-width: 1px; border-color: rgba(1, 0, 0, 0.45);"
              aria-hidden="true">
              <legend style="font-size: smaller; margin-left: 8px;">Spectra sources</legend>
              <div style="width: 100%; height: 100%;">
                <template v-if="ppp !== null">
                  <v-layout row align-content-start>

                    <v-flex
                      fluid xs12 sm12 md6 lg6 xl6
                      v-for="pw in ppp.plate_wells" :key="pw.plate.id"
                    >
                      <plate-wells
                        :plate_id="pw.plate.id"
                        :well_num_list="pw.well_num_list"
                        :well_color="ppp.probe.color !== null ? ppp.probe.color : ppp.probe.dye.color"
                      ></plate-wells>
                    </v-flex>

                  </v-layout>
                </template>
              </div>
            </fieldset>
          </v-flex>

          <!-- New spectra sources -->
          <v-flex xs12 sm6 md4 lg4 xl4>
            <fieldset
              style="border-radius: 4px; border-width: 1px; border-color: rgba(1, 0, 0, 0.45);"
              aria-hidden="true">
              <legend style="font-size: smaller; margin-left: 8px;">New spectra sources</legend>
              <div style="width: 100%; height: 100%;">
                <v-layout fluid align-content-start>

                  <v-flex fluid>
                    <plate-wells
                      :plate_id="plate.id"
                      :well_num_list="selected_wells"
                      well_color="#000000"
                    ></plate-wells>
                  </v-flex>

                </v-layout>
              </div>
            </fieldset>
          </v-flex>
        </v-layout>
      </v-container>
    </template>

    <template #actions-center>
      <v-col>
      </v-col>
    </template>

    <template #actions-right>
      <v-col>
        <v-btn
          ref="btnAdd" @click="btnAccept_click(action='ADD')"
          :disabled="ppp === null">
          Add
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          ref="btnSet" @click="btnAccept_click(action='SET')"
          :disabled="ppp === null">
          Set
        </v-btn>
      </v-col>
    </template>

  </default-dialog>
</template>

<script>

	import format from 'string-format'
	import {mapGetters, mapActions} from 'vuex'
	import DefaultDialog from "../DefaultDialog"
	import PlateWellsComponent from "../plate/PlateWellsComponent"

	export default {
		name: "probePlexProbe-source-dialog",
		components: {
			DefaultDialog,
			'plate-wells': PlateWellsComponent,
		},

		data: function () {
			return {
				inputs: {
					plate_id: -1,
					well_nums: [],
				},

				probePlex_selected: null,
				probePlexProbe_selected: null,

				probePlex_list_filtered: [],
				probePlexProbe_list_filtered: [],

				ppp: null,

				ppp_well_list: [],

				txt: '',
			}
		},

		props: {
			value: {type: Boolean, default: false,},

			// New spectra sources
			plate: {type: Object, default: () => null,},
			selected_wells: {type: Array, default: () => [],},
		},

		computed: {
			...mapGetters({
				project_selected: 'project/selected',

				probePlex_list: 'probePlex/probePlex_list',
				probePlexes: 'probePlex/probePlexes',
			}),

			probePlexProbe_items: function () {
				return []
			},

			state: function () {
				return {
					probePlex_selected: this.probePlex_selected,
					probePlexProbe_selected: this.probePlexProbe_selected,
					plate_wells: this.ppp.plate_wells,
				}
			}
		},

		watch: {
			value: function () {
				if (this.value) {
					this.load_data()
				}
			},

			probePlex_selected: function () {
				this.update_probePlexProbe_list_filtered()
			},

			probePlexProbe_selected: function () {
				console.debug("ProbePlexProbeSourceDialog.watch.probePlexProbe_selected ()")

				const pp = this.probePlexes[this.probePlex_selected]
				const ppp = pp.probes[this.probePlexProbe_selected]

				this.ppp = ppp
			},
		},

		mounted: function () {
			this.load_data()
		},

		methods: {
			...mapActions({

				message_add: 'message/add',
				progress_begin: 'progress/begin',
				progress_end: 'progress/end',
			}),

			load_data: function () {

				this.progress_begin({message: "Loading data ...",})
				Promise.all([
					this.$root.$children[0].lists_promise,

					// планшеты нужны, чтобы показывать лунки для
					// для источника калибровки спектра зондов
					this.$store.dispatch(
						'plate/list_plate',
						{project_id: this.project_selected})
				])
					.then(() => {
					})
					.catch((error) => this.message_add(error))
					.finally(() => {
						this.update_probePlex_list_filtered()
						this.progress_end()
					})
			},

			update_probePlex_list_filtered: function () {
				this.probePlex_list_filtered = this.probePlex_list
					.filter((pp) => {
						const filter_res = pp.projects.indexOf(this.project_selected) !== -1
						return filter_res
					})
			},

			update_probePlexProbe_list_filtered: function () {
				this.inputs.probePlexProbe = null
				const probePlex = this.probePlexes[this.probePlex_selected]
				this.probePlexProbe_list_filtered = probePlex.probe_list
			},

			// -- Handle actions' events --

			btnAccept_click: function (action = 'SET') {

				const plate_wells = []
				if (action === 'ADD') {
					for (const pw of this.ppp.plate_wells) {
						plate_wells.push({
							plate: {id: pw.plate.id,},
							well_num_list: pw.well_num_list,
						})
					}
				}
				plate_wells.push({
					plate: {id: this.plate.id,},
					well_num_list: this.selected_wells,
				})

				let k = 5

				this.$refs.dlgDefault.dialogAccept({
					ppp: this.ppp, // нужен полный объект, так как из него берем .probePlex.id
					plate_wells: plate_wells,
				})
			},

			// -- Handle dialog events --

		},
	}
</script>

<style scoped>

</style>